<template>
  <div class="loginPage">
    <div class="content-left">
      <img src="@/assets/images/login/loginBackground.png" alt="" />
      <div class="logos">
        <img src="@/assets/images/homePage/logo.png" alt="" />
        <span> 金融科技实践虚拟仿真教学实验平台</span>
      </div>
      <div class="intro">
        <p>
          金融科技实践虚拟仿真教学实验平台是由点宽公司提供技术支持的虚拟仿真实验教学课程共享平台，是全球第一个汇聚全部学科专业、覆盖各个层次高校、直接服务于高等院校和社会学习者使用的实验教学公共服务平台，旨在为实验教学各类型课程建设共享及应用提供全流程支撑服务，通过一流课程共享服务体系的建设，形成专业布局合理、教学效果优良、开放共享有效的高等教育实验教学新体系，提高高等教育实验教学质量和实践育人水平。
        </p>
      </div>
      <div class="copy">©2018-2022 Copyright DigQuant</div>
    </div>
    <div class="content-right">
      <login></login>
      <!-- <div class="goHomePage">
        <router-link to="/">
          <i class="el-icon-s-home"></i>
        </router-link>
      </div> -->
    </div>
  </div>
</template>

<script>
import login from "@/components/startPage/login.vue";
import { mapState } from "vuex";
export default {
  name: "VirtualimitationLogin",
  components: {
    login,
  },
  computed: {
    ...mapState(["token"]),
  },
  data () {
    return {
      loginTimer: 0
    };
  },

  watch: {
    token () {
      if (this.token) {
        this.$router.push("/");
      }
    },
  },
  mounted () {
    if (this.token) {
      this.$router.push("/");
      return;
    }
    this.doCheckLogin();
  },
  methods: {
    async doCheckLogin () {
      if (this.token) {
        return;
      }
      let tokens = "";
      const res = await this.$api.auth.IsLogin(tokens);
      if (res.errCode === 0) {
        this.$store.commit("SET_TOKEN", res.data.token);
        this.$store.dispatch("getUserInfo", JSON.stringify(res.data));
        this.$router.push("/");
      } else {
        this.checkIsLogin();
      }

    },
    checkIsLogin () {
      this.loginTimer = setTimeout(async () => {
        this.doCheckLogin();
      }, 3000);
    }
  },
};
</script>

<style lang="less" scoped>
.loginPage {
  max-width: 1900px;
  min-width: 1900px;
  width: 100%;
  height: 1080px;
  // max-height: 1080px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  .goHomePage {
    position: absolute;
    top: 200px;
    right: 100px;

    .el-icon-s-home {
      font-size: 25px;
      cursor: pointer;
    }
  }

  .content-left {
    width: 1137px;
    height: 1080px;
    position: relative;

    .copy {
      position: absolute;
      left: 469px;
      bottom: 39px;
      font-size: 13px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 18px;
      color: #ffffff;
      opacity: 1;
    }

    .intro {
      position: absolute;
      left: 104px;
      top: 821px;
      width: 918px;
      height: 94px;

      p {
        font-size: 16px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 24px;
        color: #ffffff;
        opacity: 1;
      }
    }

    .logos {
      position: absolute;
      top: 64px;
      left: 126px;
      display: flex;
      justify-content: start;
      align-items: center;

      img {
        width: 53px;
        height: 55px;
        margin-right: 25px;
      }

      span {
        font-size: 35px;
        font-family: PingFang-SC;
        font-weight: 600;
        line-height: 49px;
        color: #ffffff;
        opacity: 1;
      }
    }

    img {
      width: 1137px;
      height: 1080px;
      //   height: 100px;
    }
  }

  .content-right {
    width: 763px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;
  }

  /deep/ .el-row {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-col {
    height: 100%;
  }
}
</style>